import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29f2733e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "UserListTable"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

import { ref, reactive, computed, watch, onMounted } from 'vue';
import { useStore } from 'vuex';
import { UserGetters, UserActions } from '@/store/modules/user';
import { InfoFilled } from '@element-plus/icons-vue'
import { User } from '@/store/modules/user/types';
import { FormInstance, ElTree } from 'element-plus'
import type { FormRules } from 'element-plus'
import { CyModuleActions, CyModuleGetters, CyModuleMutations } from '@/store/modules/cyModule';
import { CyModule, CyModuleTreeNode } from '../../store/modules/cyModule/types';

import { defineComponent } from 'vue';

const __default__ = defineComponent({
    name: 'UserListTable',
});


interface option {
    value: number,
    label: string,
}

interface CreateUserParams {
    userid: number,
    username: string,
    priv: number,
    password: string,
    checkpwd: string,
    isPermanent: boolean,
    expiredtime: string,
    moduleList: option[],
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const defaultProps = {
    children: 'children',
    label: 'label',
    disabled: 'isAvailable',
}

const store = useStore();
const createUserDialogVisible = ref<boolean>(false);
const updateUserDialogVisible = ref<boolean>(false);
const defaultUserForm: CreateUserParams = {
    userid: 0,
    username: '',
    priv: 1,
    password: '',
    checkpwd: '',
    isPermanent: false,
    expiredtime: '',
    moduleList: []
}
const ruleFormRef = ref<FormInstance>()
const treeRef = ref<InstanceType<typeof ElTree>>(null);
const treeRefUpdate = ref<InstanceType<typeof ElTree>>(null);

const createUserForm: CreateUserParams = reactive(defaultUserForm)
const defaultModuleList = ref<number[]>([])

const userinfo = computed(() => {
    return store.getters[`user/${UserGetters.getUserInfo}`];
});

const userlist = computed(() => {
    return store.getters[`user/${UserGetters.getUserList}`];
});
const selectedUser = ref<User>();
const isLoading = computed(() => {
    return store.getters[`user/${UserGetters.getIsLoading}`];
});
const moduleMap = computed(() => {
    return store.getters[`cyModule/${CyModuleGetters.getCyModuleMap}`];
});
const moduleTree = computed(() => {
    return store.getters[`cyModule/${CyModuleGetters.getCyModuleTree}`];
});
const userInfo = computed(() => {
    return store.getters[`user/${UserGetters.getUserInfo}`];
});


const validatePass = (rule: any, value: any, callback: any) => {
    if (value === '') {
        callback(new Error('请输入密码'))
    } else {
        if (createUserForm.checkpwd !== '') {
            if (!ruleFormRef.value) return
            ruleFormRef.value.validateField('checkpwd', () => null)
        }
        callback()
    }
}
const validatePass2 = (rule: any, value: any, callback: any) => {
    if (value === '') {
        callback(new Error('请再次输入密码'))
    } else if (value !== createUserForm.password) {
        callback(new Error("两次输入密码不同！"))
    } else {
        callback()
    }
}
const rules = reactive<FormRules>({
    username: [{ required: true, message: '请输入用户名', trigger: 'change' }],
    priv: [{ required: true, message: '请选择用户权限', trigger: 'change' }],
    password: [{ validator: validatePass, trigger: 'blur' },
    { min: 6, message: '密码至少需6位', trigger: 'blur' },],
    checkpwd: [{ validator: validatePass2, trigger: 'blur' }],
    isPermanent: [{ required: true, message: '请选择', trigger: 'change' }],
    expiredtime: [{ required: true, message: '请选择', trigger: 'change' }],
})

const updateRules = reactive<FormRules>({
    username: [{ required: true, message: '请输入用户名', trigger: 'change' }],
    priv: [{ required: true, message: '请选择用户权限', trigger: 'change' }],
    isPermanent: [{ required: true, message: '请选择', trigger: 'change' }],
    expiredtime: [{ required: true, message: '请选择', trigger: 'change' }],
})


const resetCreateFields = () => {
    createUserForm.username = ""
    createUserForm.priv = 1
    createUserForm.checkpwd = ""
    createUserForm.password = ""
    createUserForm.isPermanent = false
    createUserForm.expiredtime = ""
    createUserForm.moduleList = []
}
const resetUpdateFields = () => {
    createUserForm.username = selectedUser.value?.username === undefined ? "" : selectedUser.value.username
    createUserForm.priv = selectedUser.value?.priv === undefined ? 1 : selectedUser.value.priv
    createUserForm.checkpwd = ""
    createUserForm.password = ""
    createUserForm.isPermanent = false
    createUserForm.expiredtime = ""
    createUserForm.moduleList = []
}

const handleCreateUser = async () => {
    resetCreateFields()
    createUserDialogVisible.value = true
}

const getUserList = async () => {
    await store.dispatch(`user/${UserActions.asyncGetUserList}`);
}

const handleDelete = async (id: number) => {
    await store.dispatch(`user/${UserActions.asyncDeleteUser}`, { id: id });
    getUserList()
}

const handleUpdate = (row: User) => {
    updateUserDialogVisible.value = true
    let timeStr = (new Date().getFullYear()) + '-' + (new Date().getMonth()) + '-' + (new Date().getDate()) + ' 23:59:59 UTC+8'
    selectedUser.value = row
    createUserForm.userid = row.id
    createUserForm.username = row.username
    createUserForm.priv = row.priv
    createUserForm.isPermanent = row.isPermanent
    createUserForm.expiredtime = row.isPermanent ? timeStr : row.expiredTime
    createUserForm.moduleList = row.moduleList === '' ? [] : row.moduleList.split(",").map(str => ({ value: Number(str), label: moduleMap.value[Number(str)].label }))
}

const asyncCreateUser = async () => {
    const moduleTypeList = createUserForm.moduleList.map(item => item.value).join(",")
    await store.dispatch(`user/${UserActions.asyncCreateUser}`, { username: createUserForm.username, priv: createUserForm.priv, password: createUserForm.password, isPermanent: createUserForm.isPermanent, expiredTime: createUserForm.isPermanent ? '1970-01-01T00:00:00.000Z' : createUserForm.expiredtime, moduleList: moduleTypeList });
}
const asyncUpdateUser = async () => {
    const moduleTypeList = createUserForm.moduleList.map(item => item.value).join(",")
    await store.dispatch(`user/${UserActions.asyncUpdateUser}`, { userid: createUserForm.userid, username: createUserForm.username, priv: createUserForm.priv, password: createUserForm.password, isPermanent: createUserForm.isPermanent, expiredTime: createUserForm.isPermanent ? '1970-01-01T00:00:00.000Z' : createUserForm.expiredtime, moduleList: moduleTypeList });
}

const createOnSubmit = async (formEl: FormInstance | undefined) => {
    if (!formEl) return
    await formEl.validate(async (valid, fields) => {
        if (!valid) {
            return
        } else {
            await asyncCreateUser()
            resetCreateFields()
            createUserDialogVisible.value = false
        }
    })
}
const createOnClear = (formEl: FormInstance | undefined) => {
    if (!formEl) return
    resetCreateFields()
}

const updateOnSubmit = async (formEl: FormInstance | undefined) => {
    if (!formEl) return
    await formEl.validate(async (valid, fields) => {
        if (!valid) return
        else {
            await asyncUpdateUser()
            resetUpdateFields()
            updateUserDialogVisible.value = false
        }
    })
}

const updateOnClear = (formEl: FormInstance | undefined) => {
    if (!formEl) return
    resetUpdateFields()
}

const getDisplayTime = (data: string) => {
    const date = (new Date(new Date(new Date(data).toUTCString()).getTime() + 8 * 60 * 60 * 1000)).toISOString()
    return date.substring(0, 10) + "  " + date.substring(11, 19)
}


watch(createUserDialogVisible, async (newVal) => {
    if (createUserDialogVisible.value === false) {
        await getUserList()
        treeRef.value.setCheckedKeys([], false)
    }
})
watch(updateUserDialogVisible, async (newVal) => {
    if (updateUserDialogVisible.value === false) {
        await getUserList()
        treeRefUpdate.value.setCheckedKeys([], false)
    } else {
        if (treeRefUpdate.value !== null && selectedUser.value !== undefined && selectedUser.value.moduleList !== '') {
            const keys = selectedUser.value.moduleList.split(",").filter(str => moduleMap.value[Number(str)] ? moduleMap.value[Number(str)].level !== 1 : false).map(str => (Number(str)))
            keys.forEach(key => {
                treeRefUpdate.value.setChecked(key, true, false)
            })
        }
    }
})
watch(treeRefUpdate, async (newVal) => {
    if (treeRefUpdate.value !== null && selectedUser.value !== undefined && selectedUser.value.moduleList !== "") {
        let list = selectedUser.value.moduleList.split(",").filter(str => moduleMap.value[Number(str)] ? moduleMap.value[Number(str)].level !== 1 : false).map(str => (Number(str)))
        list.forEach(key => {
            treeRefUpdate.value.setChecked(key, true, false)
        })
    }
})

const handleCheckChange = (data: CyModuleTreeNode, checked: boolean, indeterminate: boolean) => {
    const isSelected: boolean = createUserForm.moduleList.some(item =>
        item.label === data.label && item.value === data.type
    )
    if ((checked || indeterminate) && !isSelected) {
        createUserForm.moduleList.push({ value: data.type, label: data.label })
    } else if ((!checked && !indeterminate) && isSelected) {
        createUserForm.moduleList = createUserForm.moduleList.filter(item => item.value != data.type)
    }
}
const handleChange = (data: CyModuleTreeNode, status: any) => {
    if (data.name === "mega") {
        treeRef.value.setChecked(data.parentTypeId, true, false)
    }
}
const handleChangeUpdate = (data: CyModuleTreeNode, status: any) => {
    if (data.name === "mega") {
        treeRefUpdate.value.setChecked(data.parentTypeId, true, false)
    }
}

const removeTag = (tagValue: any) => {
    treeRef.value.setChecked(tagValue.value, false, true)
}
const removeTagUpdate = (tagValue: any) => {
    treeRefUpdate.value.setChecked(tagValue.value, false, true)
}

onMounted(async () => {
    await store.dispatch(`user/${UserActions.asyncGetOwnInfo}`, {});
    await store.dispatch(`cyModule/${CyModuleActions.asyncGetCyModuleList}`, { userId: userInfo.value.id });
})


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", null, [
      (_unref(userinfo) !== null)
        ? (_openBlock(), _createBlock(_component_el_dialog, {
            key: 0,
            modelValue: createUserDialogVisible.value,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((createUserDialogVisible).value = $event)),
            title: "新建用户",
            width: "50%"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form, {
                ref_key: "ruleFormRef",
                ref: ruleFormRef,
                model: createUserForm,
                "label-width": "120px",
                rules: rules
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "用户名",
                    prop: "username"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: createUserForm.username,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((createUserForm.username) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "权限" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio_group, {
                        modelValue: createUserForm.priv,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((createUserForm.priv) = $event)),
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio_button, { label: 1 }, {
                            default: _withCtx(() => [
                              _createTextVNode("Lv 1")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_radio_button, {
                            label: 2,
                            disabled: _unref(userinfo).priv <= 2
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Lv 2")
                            ]),
                            _: 1
                          }, 8, ["disabled"]),
                          _createVNode(_component_el_radio_button, {
                            label: 3,
                            disabled: _unref(userinfo).priv <= 3
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Lv 3")
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "是否为永久用户",
                    prop: "isPermanent"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio_group, {
                        modelValue: createUserForm.isPermanent,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((createUserForm.isPermanent) = $event)),
                        size: "default"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio_button, { label: true }, {
                            default: _withCtx(() => [
                              _createTextVNode("是")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_radio_button, { label: false }, {
                            default: _withCtx(() => [
                              _createTextVNode("否")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  (createUserForm.isPermanent === false)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        label: "有效期至",
                        prop: "expiredtime"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: createUserForm.expiredtime,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((createUserForm.expiredtime) = $event)),
                            type: "datetime",
                            placeholder: "请选择到期时间",
                            size: "default",
                            "default-time": new Date((new Date().getFullYear()) + '-' + (new Date().getMonth()) + '-' + (new Date().getDate()) + ' 23:59:59 UTC+8')
                          }, null, 8, ["modelValue", "default-time"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_form_item, {
                    label: "密码",
                    prop: "password"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: createUserForm.password,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((createUserForm.password) = $event)),
                        type: "password",
                        autocomplete: "off"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "确认密码",
                    prop: "checkpwd"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: createUserForm.checkpwd,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((createUserForm.checkpwd) = $event)),
                        type: "password",
                        autocomplete: "off"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "模块权限",
                    prop: "moduleList"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: createUserForm.moduleList,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((createUserForm.moduleList) = $event)),
                        multiple: "",
                        "collapse-tags": "",
                        placeholder: "Select",
                        style: {"width":"240px"},
                        "collapse-tags-tooltip": "",
                        onRemoveTag: removeTag
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            value: _unref(moduleTree),
                            class: "eloption",
                            disabled: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(ElTree), {
                                ref_key: "treeRef",
                                ref: treeRef,
                                class: "elTree",
                                data: _unref(moduleTree),
                                props: defaultProps,
                                "show-checkbox": "",
                                "node-key": "type",
                                "default-expand-all": "",
                                "expand-on-click-node": false,
                                "check-on-click-node": "",
                                onCheckChange: handleCheckChange,
                                onCheck: handleChange
                              }, null, 8, ["data"])
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (createOnSubmit(ruleFormRef.value)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("创建")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (createOnClear(ruleFormRef.value)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("清空")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"])
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_unref(userinfo) !== null)
        ? (_openBlock(), _createBlock(_component_el_dialog, {
            key: 1,
            modelValue: updateUserDialogVisible.value,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((updateUserDialogVisible).value = $event)),
            title: "编辑用户",
            width: "50%"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form, {
                ref_key: "ruleFormRef",
                ref: ruleFormRef,
                model: createUserForm,
                "label-width": "120px",
                rules: updateRules
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "用户ID" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(createUserForm.userid), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "用户名",
                    prop: "username"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: createUserForm.username,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((createUserForm.username) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "权限",
                    prop: "priv"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio_group, {
                        modelValue: createUserForm.priv,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((createUserForm.priv) = $event)),
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio_button, { label: 1 }, {
                            default: _withCtx(() => [
                              _createTextVNode("Lv 1")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_radio_button, {
                            label: 2,
                            disabled: _unref(userinfo).priv <= 2
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Lv 2")
                            ]),
                            _: 1
                          }, 8, ["disabled"]),
                          _createVNode(_component_el_radio_button, {
                            label: 3,
                            disabled: _unref(userinfo).priv <= 3
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Lv 3")
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "是否为永久用户",
                    prop: "isPermanent"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio_group, {
                        modelValue: createUserForm.isPermanent,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((createUserForm.isPermanent) = $event)),
                        size: "default"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio_button, { label: true }, {
                            default: _withCtx(() => [
                              _createTextVNode("是")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_radio_button, { label: false }, {
                            default: _withCtx(() => [
                              _createTextVNode("否")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  (createUserForm.isPermanent === false)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        label: "有效期至",
                        prop: "expiredtime"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: createUserForm.expiredtime,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((createUserForm.expiredtime) = $event)),
                            type: "datetime",
                            placeholder: "请选择到期时间",
                            size: "default"
                          }, null, 8, ["modelValue"]),
                          _createTextVNode(" (修改次数:" + _toDisplayString(selectedUser.value ? selectedUser.value.changeTimeCount : 0) + ") ", 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_form_item, {
                    label: "密码",
                    prop: "password"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: createUserForm.password,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((createUserForm.password) = $event)),
                        type: "password",
                        autocomplete: "off"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "确认密码",
                    prop: "checkpwd"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: createUserForm.checkpwd,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((createUserForm.checkpwd) = $event)),
                        type: "password",
                        autocomplete: "off"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "模块权限",
                    prop: "moduleList"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: createUserForm.moduleList,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((createUserForm.moduleList) = $event)),
                        multiple: "",
                        "collapse-tags": "",
                        placeholder: "Select",
                        style: {"width":"240px"},
                        "collapse-tags-tooltip": "",
                        onRemoveTag: removeTagUpdate
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            value: _unref(moduleTree),
                            class: "eloption",
                            disabled: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(ElTree), {
                                ref_key: "treeRefUpdate",
                                ref: treeRefUpdate,
                                class: "elTree",
                                data: _unref(moduleTree),
                                props: defaultProps,
                                "show-checkbox": "",
                                "node-key": "type",
                                "default-expand-all": "",
                                "expand-on-click-node": false,
                                "check-on-click-node": "",
                                onCheckChange: handleCheckChange,
                                onCheck: handleChangeUpdate
                              }, null, 8, ["data"])
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _cache[17] || (_cache[17] = ($event: any) => (updateOnSubmit(ruleFormRef.value)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("更新")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        onClick: _cache[18] || (_cache[18] = ($event: any) => (updateOnClear(ruleFormRef.value)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("清空")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"])
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ])), [
      [_directive_loading, _unref(isLoading)]
    ]),
    (_unref(userinfo) !== null)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_el_button, {
            class: "create-user",
            type: "primary",
            onClick: handleCreateUser
          }, {
            default: _withCtx(() => [
              _createTextVNode("新建用户")
            ]),
            _: 1
          }),
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            data: _unref(userinfo).priv === 3 ? _unref(userlist) : [_unref(userinfo)].concat(_unref(userlist))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                align: "center",
                prop: "id",
                label: "ID"
              }),
              _createVNode(_component_el_table_column, {
                align: "center",
                prop: "username",
                label: "用户名"
              }),
              _createVNode(_component_el_table_column, {
                align: "center",
                prop: "priv",
                label: "权限"
              }),
              _createVNode(_component_el_table_column, {
                align: "center",
                label: "有效期"
              }, {
                default: _withCtx((scope) => [
                  (scope.row.isPermanent === true)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_2, "永久"))
                    : _createCommentVNode("", true),
                  (scope.row.isPermanent === false)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(getDisplayTime(scope.row.expiredTime)), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                align: "center",
                label: "操作"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    size: "small",
                    onClick: ($event: any) => (handleUpdate(scope.row)),
                    disabled: scope.row.priv === 3 || scope.row.priv >= _unref(userinfo).priv
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("编辑")
                    ]),
                    _: 2
                  }, 1032, ["onClick", "disabled"]),
                  _createVNode(_component_el_popconfirm, {
                    width: "220",
                    "confirm-button-text": "删除",
                    "cancel-button-text": "取消",
                    title: "确定删除此用户？",
                    icon: _unref(InfoFilled),
                    "icon-color": "red",
                    onConfirm: ($event: any) => (handleDelete(scope.row.id))
                  }, {
                    reference: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "danger",
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("删除")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["icon", "onConfirm"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, _unref(isLoading)]
          ])
        ])), [
          [_directive_loading, _unref(isLoading)]
        ])
      : _createCommentVNode("", true)
  ], 64))
}
}

})